export const contentAiZh:Record<string,string> = {
  'copy.zhihu_topics_hint':'AI 话题是候选关键词，发布时按顺序添加最多3个完全匹配的知乎话题，未匹配或超出上限的会跳过并记录。',
  'copy.settings':'AI 发布文案',
  'copy.settings_hint':'配置千枢等 OpenAI 兼容网关，供当前企业生成发布文案。密钥仅在服务器加密保存。',
  'copy.enabled':'启用 AI 文案生成',
  'copy.base_url':'网关 Base URL（包含 /v1，不含 /chat/completions）',
  'copy.model':'文案 / 视频画面理解模型 ID',
  'copy.asr_model':'语音转写模型 ID（视频含音轨时使用）',
  'copy.key':'API Key',
  'copy.key_saved':'已保存；留空保留原密钥',
  'copy.key_empty':'尚未配置',
  'copy.clear_key':'清除已保存的密钥',
  'copy.video_audio':'启用视频分析（画面理解＋语音转写）',
  'copy.daily_limit':'企业每日生成次数上限（北京时间）',
  'copy.save':'保存配置',
  'copy.saved':'模型配置已保存',
  'copy.save_failed':'模型配置保存失败，请检查输入并重试',
  'copy.load_failed':'AI 配置加载失败，请重试',
  'copy.reload':'重新加载',
  'copy.title':'AI 生成发布文案',
  'copy.hint':'分析所选素材和当前编辑内容，只生成{field}。其他字段保持原样，确认填入后仍可编辑。',
  'copy.brief':'补充主题、目标客户、已确认的产品事实或文案风格（可选）',
  'copy.consent':'允许将此素材、当前编辑内容与补充需求发送至本企业配置的模型网关进行分析',
  'copy.generate':'AI 生成',
  'copy.running':'生成中',
  'copy.result_ready':'查看结果',
  'copy.pending':'正在分析素材和生成文案…',
  'copy.queued':'任务已提交，正在排队',
  'copy.processing':'正在读取素材、分析画面和声音并生成文案',
  'copy.elapsed':'已等待 {minutes} 分 {seconds} 秒',
  'copy.background':'视频分析可能需要数分钟。任务在后台继续，刷新页面或稍后返回可恢复进度，不必重复生成。',
  'copy.status_failed':'暂时无法读取任务进度，后台任务仍会继续，请重新查询。',
  'copy.check_status':'重新查询进度',
  'copy.recover':'恢复上次 AI 生成',
  'copy.recover_hint':'找到您最近一次 AI 生成任务，可继续查看进度或取回结果。',
  'copy.editor_restored':'已恢复此标签页的素材和编辑内容，尚未保存的修改请保存云端稿件。',
  'copy.editor_storage_failed':'浏览器暂时无法保留编辑内容，请及时保存云端稿件；AI 任务仍可从服务器恢复。',
  'copy.start_fresh':'清空并新建',
  'copy.start_fresh_confirm':'清空当前编辑内容并新建？已提交的 AI 任务仍在后台保留。',
  'copy.choose_asset_first':'选择素材后设置账号',
  'copy.choose_account_below':'选择下方本机账号',
  'copy.leave_editor':'保留当前标签页的编辑内容并离开？正式稿件仍需保存云端。',
  'copy.leave':'保留并离开',
  'copy.not_configured':'企业尚未启用模型网关，请先完成 AI 发布文案配置。',
  'copy.configure':'前往系统设置',
  'copy.plan_required':'当前套餐未开通 AI 内容能力。',
  'copy.video_required':'当前模型尚未确认视频画面与声音理解能力，请先检查模型配置。',
  'copy.limit':'首期视频分析支持 MP4，不超过20MiB、120秒；知乎文档不超过2万字。不会裁剪视频。',
  'copy.summary':'素材内容摘要',
  'copy.generated_title':'候选标题',
  'copy.generated_body':'候选正文',
  'copy.generated_tags':'候选话题 / 标签',
  'copy.review':'请核对事实和表述。相关话题不代表平台实时热门话题。',
  'copy.apply':'确认并填入当前平台',
  'copy.overwrite_title':'替换当前字段？',
  'copy.overwrite':'确认后仅替换{field}，其余字段保持原样。',
  'copy.changed':'编辑内容已变化，请重新生成候选文案。',
  'copy.applied':'候选文案已填入，请检查后保存稿件',
  'copy.cached':'已复用最近生成结果，未重复调用模型',
  'copy.usage':'本次模型返回的 Token 用量：{tokens}',
  'copy.quota':'含音轨的视频通常调用2次模型，计入套餐 AI 次数；网关也可能收费，失败不会自动重试。',
  'copy.error':'生成失败，请检查模型配置或稍后重试',
}

export const contentAiEn:Record<string,string> = {
  'copy.zhihu_topics_hint':'AI topics are candidates. Up to 3 exact matches are added in order; unmatched or excess topics are skipped and recorded.',
  'copy.settings':'AI publishing copy',
  'copy.settings_hint':'Configure your company’s OpenAI-compatible gateway, including Qianshu. API keys are encrypted on the server.',
  'copy.enabled':'Enable AI copy generation',
  'copy.base_url':'Gateway base URL (include /v1, exclude /chat/completions)',
  'copy.model':'Copy / video vision model ID',
  'copy.asr_model':'Speech transcription model ID (for videos with audio)',
  'copy.key':'API key',
  'copy.key_saved':'Saved; leave blank to keep the current key',
  'copy.key_empty':'Not configured',
  'copy.clear_key':'Remove the saved key',
  'copy.video_audio':'Enable video analysis (vision and speech transcription)',
  'copy.daily_limit':'Daily company generation limit (Beijing time)',
  'copy.save':'Save configuration',
  'copy.saved':'Model configuration saved',
  'copy.save_failed':'Could not save model settings. Check the fields and retry.',
  'copy.load_failed':'Could not load AI settings. Please retry.',
  'copy.reload':'Reload',
  'copy.title':'Generate publishing copy with AI',
  'copy.hint':'Analyze the material and current edits to generate only {field}. Other fields are kept. Review before applying.',
  'copy.brief':'Optional topic, audience, confirmed product facts or writing style',
  'copy.consent':'Allow this material, current edits and brief to be sent to the company’s configured model gateway',
  'copy.generate':'AI generate',
  'copy.running':'Generating',
  'copy.result_ready':'View result',
  'copy.pending':'Analyzing material and generating copy…',
  'copy.queued':'Submitted and waiting in the queue',
  'copy.processing':'Reading material, analyzing video and speech, and generating copy',
  'copy.elapsed':'Elapsed: {minutes} min {seconds} sec',
  'copy.background':'Video analysis can take several minutes. The task continues in the background. Refresh or return later to resume without generating again.',
  'copy.status_failed':'Progress is temporarily unavailable. The background task continues; check its status again.',
  'copy.check_status':'Check progress again',
  'copy.recover':'Resume last AI generation',
  'copy.recover_hint':'Your recent AI generation can be resumed or its result retrieved.',
  'copy.editor_restored':'Material and edits in this tab have been restored. Save your changes as a cloud draft.',
  'copy.editor_storage_failed':'This browser cannot retain your edits right now. Save a cloud draft; AI tasks can still be recovered from the server.',
  'copy.start_fresh':'Clear and start new',
  'copy.start_fresh_confirm':'Clear these edits and start new? Submitted AI tasks remain on the server.',
  'copy.choose_asset_first':'Choose material before setting the account',
  'copy.choose_account_below':'Choose a local account below',
  'copy.leave_editor':'Keep this tab’s edits and leave? Save a cloud draft to retain the formal version.',
  'copy.leave':'Keep and leave',
  'copy.not_configured':'The company model gateway is not enabled. Configure AI publishing copy first.',
  'copy.configure':'Open system settings',
  'copy.plan_required':'Your plan does not include AI content.',
  'copy.video_required':'Video and sound understanding has not been confirmed for this model. Check its configuration.',
  'copy.limit':'Video analysis supports MP4 up to 20MiB and 120 seconds. Zhihu documents are limited to 20,000 characters. Videos are not trimmed.',
  'copy.summary':'Material summary',
  'copy.generated_title':'Suggested title',
  'copy.generated_body':'Suggested body',
  'copy.generated_tags':'Suggested topics / tags',
  'copy.review':'Check facts and wording. Related topics are not verified trending topics.',
  'copy.apply':'Review and apply to this platform',
  'copy.overwrite_title':'Replace this field?',
  'copy.overwrite':'Only {field} will be replaced. All other fields are kept.',
  'copy.changed':'The editor has changed. Generate a new suggestion.',
  'copy.applied':'Suggestion applied. Check and save the draft.',
  'copy.cached':'Reused a recent result without another model call',
  'copy.usage':'Tokens reported by the model: {tokens}',
  'copy.quota':'Videos with audio usually require two model calls, counted toward your AI quota. Gateway charges may apply. Failures are not automatically retried.',
  'copy.error':'Generation failed. Check the model configuration or retry later.',
}
